import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import HolidayHoursEditForm from './components/HolidayHoursEditForm';

import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import { useGetFilterInitialState } from './hooks/useGetFilterInitialState';
import { useGetTableData } from './hooks/useGetTableData';
import { StyledHolidayHoursBox } from './HolidayHours.styles';

const HolidayHours = () => {
  const { data, isFetching } = useGetTableData();
  const columns = useGetColumnDefs();
  const initialState = useGetFilterInitialState();

  return (
    <StyledHolidayHoursBox>
      <TableCRUDLayout
        initialState={initialState}
        FormComponent={HolidayHoursEditForm}
        rows={data}
        loading={isFetching}
        columns={columns}
        getRowId={(row) => row.periodSetupId}
        hideCreateAction={true}
      />
    </StyledHolidayHoursBox>
  );
};
export default HolidayHours;
